import React, { useState } from "react";
import { projects } from "../../data/portfolio";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import SectionHeader from "../SectionHeader/SectionHeader";
import { FiGithub, FiExternalLink, FiFolder } from "react-icons/fi";
import "./Projects.css";

function FeaturedProject({ project, index }) {
  const [ref, visible] = useScrollReveal(0.15);
  const direction = index % 2 === 0 ? 'reveal--left' : 'reveal--right';

  return (
    <div
      ref={ref}
      className={`projects__featured-card ${index % 2 !== 0 ? "projects__featured-card--reverse" : ""} reveal ${direction} ${visible ? 'reveal--visible' : ''}`}
    >
      <div className="projects__featured-image">
        {project.image ? (
          <img
            src={project.image}
            alt={project.title}
            className="projects__featured-img"
          />
        ) : (
          <div className="projects__featured-placeholder">
            <FiFolder />
            <span>{project.title}</span>
          </div>
        )}
      </div>

      <div className="projects__featured-content">
        <p className="projects__featured-label">Featured Project</p>
        <h3 className="projects__featured-title">{project.title}</h3>
        <p className="projects__featured-tagline">{project.tagline}</p>

        <div className="projects__featured-desc">
          <p>{project.description}</p>
        </div>

        <div className="projects__featured-tech">
          {project.tech.map((t) => (
            <span key={t}>{t}</span>
          ))}
        </div>

        <div className="projects__featured-links">
          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FiGithub />
            </a>
          )}
          {project.live && (
            <a
              href={project.live}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Live Demo"
            >
              <FiExternalLink />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

function Projects() {
  const [showAll, setShowAll] = useState(false);

  const featured = projects.filter((p) => p.featured);
  // const others = projects.filter((p) => !p.featured);
  const others = 0;

  return (
    <section className="projects section" id="projects">
      <div className="container">
        <SectionHeader title="Projects" subtitle="Things I've built" />

        <div className="projects__featured">
          {featured.map((project, index) => (
            <FeaturedProject key={project.id} project={project} index={index} />
          ))}
        </div>

        {others.length > 0 && (
          <>
            <h3 className="projects__other-heading">
              Other Noteworthy Projects
            </h3>
            <div
              className={`projects__other-grid ${showAll ? "" : "projects__other-grid--collapsed"}`}
            >
              {others.map((project) => (
                <div className="projects__other-card" key={project.id}>
                  <div className="projects__other-header">
                    <FiFolder className="projects__other-folder" />
                    <div className="projects__other-links">
                      {project.github && (
                        <a
                          href={project.github}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="GitHub"
                        >
                          <FiGithub />
                        </a>
                      )}
                      {project.live && (
                        <a
                          href={project.live}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Live Demo"
                        >
                          <FiExternalLink />
                        </a>
                      )}
                    </div>
                  </div>

                  <h4 className="projects__other-title">{project.title}</h4>
                  <p className="projects__other-tagline">{project.tagline}</p>
                  <p className="projects__other-desc">{project.description}</p>

                  <div className="projects__other-tech">
                    {project.tech.map((t) => (
                      <span key={t}>{t}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            {others.length > 3 && (
              <div className="projects__toggle">
                <button
                  className="btn btn--outline"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "Show Less" : "Show More"}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}

export default Projects;
